module.exports = __webpack_public_path__ + "img/41.51aca4c3.png";